module.exports = __webpack_public_path__ + "img/Excel-icon.d72462aa.png";